const environment = {
    apiAuthAgentUrl: "https://api-gateway-staging.cyberprotect.cloud/auth",
    apiAuthCustomerUrl: "https://api-gateway-staging.cyberprotect.cloud/auth-customer",
}

export default environment;
